import * as React from 'react';

interface IFormRow {
    children: Array<JSX.Element> | JSX.Element;
    className?: string;
    style?: React.CSSProperties;
    align?: string;
}

const FormRow: React.FC<IFormRow> = (props) => {
    const style: React.CSSProperties = {
        ...props.style,
        justifyContent: props.align && props.align === 'right' ? 'flex-end' : 'inherit',
    };

    return (
        <div className={`dlc-form-row ${props.className || ''}`} style={style}>
            {props.children}
        </div>
    );
};

FormRow.displayName = 'FormRow';

export default FormRow;



// WEBPACK FOOTER //
// ./src/components/controls/forms/FormRow.tsx